export default function pairs(values, pairof) {
    if (pairof === void 0) { pairof = pair; }
    var pairs = [];
    var previous;
    var first = false;
    for (var _i = 0, values_1 = values; _i < values_1.length; _i++) {
        var value = values_1[_i];
        if (first)
            pairs.push(pairof(previous, value));
        previous = value;
        first = true;
    }
    return pairs;
}
export function pair(a, b) {
    return [a, b];
}
